import type { FC } from 'react';

import { typographyVariants } from '@mint-lib/tw-components';

type Props = {
  title: string;
  description?: string;
};

const TabContentHeader: FC<Props> = ({ title, description }) => {
  return (
    <div className="grid gap-1.5">
      <h4 className={typographyVariants({ variant: 'h4' })}>{title}</h4>
      {description ? (
        <p
          className={typographyVariants({
            variant: 'bodyLong01',
            color: 'secondary',
          })}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default TabContentHeader;
